import Logger from "./Logger";
const logger = new Logger();

const cookies = {
  store: (cname, cvalue, options) => {
    let domain;
    if (options == null) {
      options = {};
    }
    const values = [`${cname}=${cvalue}`, "path=/"];
    if (options.tld) {
      const tokens = window.location.hostname.split(".");
      tokens.shift();
      domain = tokens.join(".");
    } else {
      domain = window.location.hostname;
    }

    values.push(`domain=.${domain}`);

    if (options.duration) {
      const d = new Date();
      d.setTime(d.getTime() + options.duration);
      options.expires = d.toGMTString();
    }

    if (options.expires) {
      values.push(`expires=${options.expires}`);
    }

    const cookie = values.join("; ");
    logger.log(`writing cookie: ${cookie}`);
    return (document.cookie = cookie);
  },
  dispose: (cname, options) => {
    if (options == null) {
      options = {};
    }
    options.expires = "Thu, 01 Jan 1970 00:00:01 GMT";
    return cookies.store(cname, "", options);
  },
  read: cname => {
    const name = `${cname}=`;
    const ca = document.cookie.split(";");
    let i = 0;
    while (i < ca.length) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) !== -1) {
        return c.substring(name.length, c.length);
      }
      i++;
    }
    return "";
  },
};

export default cookies;
